import React, { useEffect } from 'react';
import Header from '../components/ui/Header';
import Footer from '../components/ui/Footer';
import { Badge } from '../components/ui/badge';

const Newsletter = () => {
  useEffect(() => {
    window.scrollTo(0, 0);

    // Load the form embed script
    const script = document.createElement('script');
    script.src = 'https://book.phosstudio.net/js/form_embed.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup script on unmount
      const existingScript = document.querySelector('script[src="https://book.phosstudio.net/js/form_embed.js"]');
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);

  return (
    <div className="min-h-screen relative z-[1]">
      <Header />
      <div className="pt-32 pb-20">
        <section className="py-12 relative">
          <div className="container mx-auto px-6">
            <div className="max-w-3xl mx-auto">
              <div className="text-center mb-12">
                <Badge className="bg-amber-500/20 text-amber-400 border-amber-500/50 mb-4">Newsletter</Badge>
                <h1 className="text-4xl sm:text-5xl md:text-6xl font-black text-white mb-6">
                  The Underpaid <span className="bg-gradient-to-r from-amber-400 to-yellow-300 bg-clip-text text-transparent">Producer</span>
                </h1>
                <p className="text-lg sm:text-xl text-slate-400 max-w-2xl mx-auto">
                  Tips, insights, and strategies for content creators who are ready to level up.
                </p>
              </div>

              {/* Newsletter Form Embed */}
              <div className="bg-slate-900/50 border border-amber-500/30 backdrop-blur-sm rounded-2xl shadow-2xl shadow-amber-500/10 overflow-hidden">
                <iframe
                  src="https://book.phosstudio.net/widget/form/6FKMiETPKxL0g9ZZbjPL"
                  style={{ width: '100%', height: '635px', border: 'none', borderRadius: '1px' }}
                  id="inline-6FKMiETPKxL0g9ZZbjPL"
                  data-layout="{'id':'INLINE'}"
                  data-trigger-type="alwaysShow"
                  data-trigger-value=""
                  data-activation-type="alwaysActivated"
                  data-activation-value=""
                  data-deactivation-type="neverDeactivate"
                  data-deactivation-value=""
                  data-form-name="Underpaid Producer Newsletter"
                  data-height="635"
                  data-layout-iframe-id="inline-6FKMiETPKxL0g9ZZbjPL"
                  data-form-id="6FKMiETPKxL0g9ZZbjPL"
                  title="Underpaid Producer Newsletter"
                />
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default Newsletter;
